import React from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { cn } from '../../utils/cn';

export const SortIcons = ({ sortBy, sortOrder, colKey, onSort }) => {
  const isActive = sortBy === colKey;

  const handleAscClick = (e) => {
    e.stopPropagation();
    if (!onSort) return;
    if (sortBy === colKey && sortOrder === 'asc') {
      onSort('', '');
    } else {
      onSort(colKey, 'asc');
    }
  };

  const handleDescClick = (e) => {
    e.stopPropagation();
    if (!onSort) return;
    if (sortBy === colKey && sortOrder === 'desc') {
      onSort('', '');
    } else {
      onSort(colKey, 'desc');
    }
  };

  return (
    <div className="flex flex-col">
      <ArrowUpwardIcon
        fontSize="small"
        className={cn('cursor-pointer opacity-70 hover:opacity-100', isActive && sortOrder === 'asc' && 'text-primary-500 opacity-100')}
        onClick={handleAscClick}
      />
      <ArrowDownwardIcon
        fontSize="small"
        className={cn('cursor-pointer opacity-70 hover:opacity-100', isActive && sortOrder === 'desc' && 'text-primary-500 opacity-100')}
        onClick={handleDescClick}
      />
    </div>
  );
};
